import {  createActionGroup, emptyProps, props } from '@ngrx/store';

export const ClaimActions = createActionGroup({
  source: 'Claim',
  events: {
    'Claim Reward': props<{profileId:string; rewardIds: string[] }>(),
    'Claim Reward Success': props<{ data: any }>(),
    'Claim Reward Failure': props<{ error: string }>(),
    "Claim Reset":emptyProps(),
  },
});
